//行页管理器
import { PageConfig, PrintElement } from '../types/PrintElement';

export class PageManager {
  private pageConfig: PageConfig;
  private commands: string[];

  constructor(pageConfig: PageConfig, commands: string[]) {
    this.pageConfig = pageConfig;
    this.commands = commands;
    this.pageConfig.bodyStartTop = this.pageConfig.bodyStartTop ?? this.pageConfig.itemBeginHeight;
    this.pageConfig.footerReserveHeight = this.pageConfig.footerReserveHeight ?? 15;
    this.pageConfig.bodyEndTop = this.pageConfig.bodyEndTop ?? (this.pageConfig.pageHeight - this.pageConfig.footerReserveHeight);
    this.pageConfig.pageNumber = this.pageConfig.pageNumber ?? 1;
  }

  public isFixedElement(element: PrintElement): boolean {
    return element.layoutMode === 'fixed' || element.itemType === 1 || element.itemType === 2;
  }

  public getCurrentTop(): number {
    return this.pageConfig.currentTop;
  }

  public getBodyStartTop(): number {
    return this.pageConfig.bodyStartTop ?? this.pageConfig.itemBeginHeight;
  }

  public getBodyEndTop(): number {
    return this.pageConfig.bodyEndTop ?? (this.pageConfig.pageHeight - (this.pageConfig.footerReserveHeight ?? 15));
  }

  public getPageNumber(): number {
    return this.pageConfig.pageNumber ?? 1;
  }

  public setBodyBounds(bodyStartTop: number, bodyEndTop?: number): void {
    this.pageConfig.bodyStartTop = bodyStartTop;
    this.pageConfig.itemBeginHeight = bodyStartTop;
    if (bodyEndTop !== undefined) {
      this.pageConfig.bodyEndTop = bodyEndTop;
    }
  }

  public canFit(height: number, top?: number): boolean {
    const currentTop = top ?? this.pageConfig.currentTop;
    return currentTop + height <= this.getBodyEndTop();
  }

  public ensureSpace(height: number): number {
    const currentTop = this.pageConfig.currentTop;
    if (currentTop > this.getBodyStartTop() && !this.canFit(height, currentTop)) {
      return this.startNewPage();
    }
    return currentTop;
  }

  public startNewPage(): number {
    this.commands.push('LODOP.NEWPAGE();');
    this.pageConfig.pageNumber = this.getPageNumber() + 1;
    this.pageConfig.currentTop = this.getBodyStartTop();
    return this.pageConfig.currentTop;
  }

  public placeElement(element: PrintElement): number {
    const elementHeight = this.calculateElementHeight(element);
    const spacingAfter = element.spacingAfter ?? 0;
    const top = this.ensureSpace(elementHeight);
    this.pageConfig.currentTop = top + elementHeight + spacingAfter;
    return top;
  }

  public updatePageHeight(element: PrintElement): void {
    const elementHeight = this.calculateElementHeight(element);
    this.pageConfig.currentTop += elementHeight;
  }

  public getPageConfig(): PageConfig {
    return this.pageConfig;
  }

  public setCurrentTop(top: number): void {
    this.pageConfig.currentTop = top;
  }

  public increaseTop(increment: number): void {
    this.pageConfig.currentTop += increment;
  }

  public calculateElementHeight(element: PrintElement): number {
    if (typeof element.estimatedHeight === 'number' && !Number.isNaN(element.estimatedHeight)) {
      return element.estimatedHeight;
    }

    const heightStr = element.height;
    const heightMatch = heightStr.match(/\d+(?:\.\d+)?/);
    return heightMatch ? parseFloat(heightMatch[0]) : 3;
  }
}
